export default __webpack_public_path__ + "static/media/WBTCe.d8219479.svg";